/** A medium for storing money or a coupon for a product, like hard cash, a credit card or a voucher. */
export enum Medium { 
	/** Hard cash (coins or bills). */
	HardCash = "HardCash", 
	/**
	* Credit card or (in Germany) EC card or payment using
	*             the smartphone with Google Pay or other mobile apps.
	*/
	Cashless = "Cashless", 
	/**
	* A provider-specific internal payment method, like
	*             the Dallmayr card.
	*/
	ClosedLoop = "ClosedLoop", 
	/**
	* A voucher like a <see cref="T:Iovent.Model.Vouchers.QR.QRVoucher" />, a <see cref="T:Iovent.Model.Vouchers.SaniFair.SaniFairVoucher" /> or a coin token.
	*             A voucher may contain credit (use <see cref="F:Iovent.Model.Vouchers.VoucherValue.Credit" />) or a specific product (use <see cref="F:Iovent.Model.Vouchers.VoucherValue.Product" />).
	*/
	Voucher = "Voucher", 
	/** Credit from a payment API (e.g. Adyen or MobilePay). */
	ApiCredit = "ApiCredit"
}
